import { tw } from 'utils/classnames'

interface RibbonProps {
  text: string
  category?: string
  className?: string
}

const colorsByCategory = {
  fonts: {
    background: '#7f42f6',
    'ribbon-tail': '#4118EA',
    text: '#fff',
  },
  graphics: {
    background: '#29ABE2',
    'ribbon-tail': '#0D6EC3',
    text: '#fff',
  },
  crafts: {
    background: '#EE2A7B',
    'ribbon-tail': '#DA0D3D',
    text: '#fff',
  },
  gray: {
    background: '#E2E4E9',
    'ribbon-tail': '#4B5563',
    text: '#272B2F',
  },
}

export const Ribbon = ({ text, category = 'gray', className }: RibbonProps) => {
  const color = colorsByCategory[category as keyof typeof colorsByCategory]
  const { background, 'ribbon-tail': ribbonTail, text: ribbonText } = color
  return (
    <div
      style={
        {
          '--ribbon-color': background,
          '--ribbon-tail': ribbonTail,
          '--ribbon-text': ribbonText,
        } as React.CSSProperties
      }
      className={tw(
        'absolute -left-[10px] -top-[15px] z-10 inline-block isolate bg-[--ribbon-color] font-bold uppercase text-[--ribbon-text] shadow-[0_4px_10px_rgba(0,0,0,0.25)]',
        'after:border-[--ribbon-tail]',
        'text-12 leading-[30px] px-3 h-[30px] tracking-[0.12em] after:border-y-[15px] after:border-r-[5px] before:-bottom-[10px] before:border-[10px]',
        'after:absolute after:-right-[5px] after:top-0 after:inline-block after:border-[--ribbon-color] after:border-r-transparent',
        'before:absolute before:left-0 before:block before:size-0 before:border-l-0 before:border-t-0 before:border-transparent before:border-r-[--ribbon-tail]',
        className,
      )}
    >
      {text}
    </div>
  )
}
